export const AppwideDrawerContentType = {
  TransferForm: 'TransferForm',
  ResolveReconMismatches: 'ResolveReconMismatches',
  CustomerSettlement: 'CustomerSettlement',
  AutoHedgePositionRule: 'AutoHedgePositionRule',
  EntityAdmin: 'EntityAdmin',
  ThemeColorGeneration: 'ThemeColorGeneration',
  CreateCustomerDeposit: 'CreateCustomerDeposit',
  InstrumentInspector: 'InstrumentInspector',
  IndexMarkEditor: 'IndexMarkEditor',
} as const;
export type AppwideDrawerContentType = (typeof AppwideDrawerContentType)[keyof typeof AppwideDrawerContentType];
